import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import ProductSearch from "../../../../components/product-search";
import Notification from "../../../../components/toast";
import reqProdutosKit from "../../../../services/reqMultiTenant/reqProdutosKit";
import functions from "../../../../util/functions";

const idDoProduto = (produto) => produto.id_produto ?? produto.id;

const avisarErro = (mensagem, error) => Notification.showToast({ message: `${mensagem}: ${error.message}`, type: "error" });

export const AbaKit = ({ idProduto }) => {
	const [itens, setItens] = useState([]);

	useEffect(() => {
		const carregar = async () => {
			try {
				const { data } = await reqProdutosKit.listKit(idProduto);
				setItens(data);
			} catch (error) {
				avisarErro("Erro ao carregar a composição", error);
			}
		};

		if (idProduto) carregar();
	}, [idProduto]);

	const handleAdicionar = async (produto) => {
		try {
			const { data } = await reqProdutosKit.addKit(idProduto, { id_produto: idDoProduto(produto), qtde: 1 });
			setItens(data);
		} catch (error) {
			avisarErro("Erro ao adicionar", error);
		}
	};

	const handleRemover = async (item) => {
		try {
			await reqProdutosKit.removeKit(idProduto, item.idkit);
			setItens((atual) => atual.filter((i) => i.idkit !== item.idkit));
		} catch (error) {
			avisarErro("Erro ao remover", error);
		}
	};

	const handleRemoverPeloProduto = (produto) => {
		const item = itens.find((i) => i.id_produto === idDoProduto(produto));
		if (item) handleRemover(item);
	};

	return (
		<div className="flex flex-col gap-3">
			<p className="text-xs text-slate-500 m-0">
				O preço cobrado é o deste produto. Os produtos da composição só definem o que ele libera para o cliente.
			</p>

			<div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
				<div className="flex flex-col shadow-sm rounded-md border border-gray-300 bg-white overflow-hidden min-h-[360px]">
					<ProductSearch
						onSelectProduct={handleAdicionar}
						onRemoveProduct={handleRemoverPeloProduto}
						customActionTitle="Adicionar à composição"
						customActionIcon={<Plus size={16} />}
						linkedIds={itens.map((i) => i.id_produto)}
						excludedIds={[idProduto]}
					/>
				</div>

				<div className="flex flex-col shadow-sm rounded-md border border-gray-300 bg-white overflow-hidden">
					<div className="px-3 py-2 border-b text-xs font-bold text-slate-500 uppercase tracking-wider">
						Inclui ({itens.length})
					</div>
					<div className="overflow-y-auto">
						<table className="w-full text-sm">
							<tbody>
								{itens.map((item) => (
									<tr key={item.idkit} className="border-b last:border-b-0">
										<td className="p-2">
											<strong>{item.nome}</strong>
											<span className="block text-[11px] text-slate-400">
												{item.tipo} · avulso {functions.strToCurrency(item.valor)}
											</span>
										</td>
										<td className="p-2 text-right">
											<button
												type="button"
												className="btn btn-sm btn-outline-danger"
												title="Remover da composição"
												onClick={() => handleRemover(item)}
											>
												<Trash2 size={14} />
											</button>
										</td>
									</tr>
								))}
								{itens.length === 0 && (
									<tr>
										<td className="p-4 text-center italic text-slate-400">
											Nenhum produto. Pesquise ao lado e adicione o que este produto libera.
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AbaKit;
